import products from "@/data/products/products";
import Image from "next/image";
import Link from "next/link";
import { m } from "framer-motion";

const containerAnimation = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.3,
      staggerChildren: 0.1,
    },
  },
};

const itemAnimation = {
  hidden: { y: 100, opacity: 0 },
  show: { y: 0, opacity: 100 },
};

const ProductsSection = () => {
  return (
    <section className="flex w-full  py-16">
      <div className="container flex flex-col items-start justify-center gap-10 px-4">
        <m.div
          className="flex w-full flex-col items-start justify-center gap-5"
          // fade in
          initial={{ opacity: 0 }}
          whileInView={{
            opacity: 1,
            transition: { duration: 0.5, ease: "easeOut" },
          }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl font-bold text-primary-700">Our Products</h2>
          <div className="text-base font-medium leading-normal text-auto-black/60">
            We offer a wide range of products to meet your market needs. Our
            products can all be customized to fit your brand and market. We
            offer a variety of packaging options to meet your needs, along with
            the flexibility to customize the product to your specifications.
          </div>
        </m.div>
        <m.div
          className="grid w-full grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3"
          // slide up from bottom
          variants={containerAnimation}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {products.map((product, index) => (
            <ProductCard key={index} product={product} />
          ))}
        </m.div>
      </div>
    </section>
  );
};

export default ProductsSection;

const ProductCard = ({ product }) => {
  return (
    <m.div variants={itemAnimation}>
      <Link
        className="group relative flex aspect-square flex-col items-center justify-center gap-5 overflow-hidden"
        href={`/product/${product.code}`}
      >
        {product.images.length > 0 ? (
          <>
            <Image
              src={product.images[0]}
              alt={product.name}
              fill
              className="absolute inset-0 object-cover object-center transition-transform duration-300 will-change-transform lg:group-hover:scale-110"
              sizes="(max-width: 600px) 460px, (max-width: 900px) 325px, (max-width: 1200px) 550px, 460px"
            />
            <div className="absolute inset-0 aspect-square w-full bg-black/40"></div>
          </>
        ) : null}
        <div className="z-10 flex translate-y-6 flex-col items-center justify-center gap-3 text-center transition-transform duration-300 will-change-transform lg:group-hover:translate-y-0">
          <h3 className="text-4xl font-bold text-white ">{product.name}</h3>
          <div className="button durarion-300 will-change-opacity opacity-0 transition-all lg:group-hover:opacity-100">
            Learn More
          </div>
        </div>
      </Link>
    </m.div>
  );
};
